import { ProfileModal } from '@apps-common/apps/my-monitoring/modals/profile/ProfileModal'
import { ProfileImage } from '@apps-common/components/common/user'
import { ModalButton } from '@apps-common/components/modals'
import { useCombinedUserDetails } from '@apps-common/hooks/useCombinedUserDetails'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'

export const UserProfileButton = () => {
  const user = useCombinedUserDetails()

  return (
    <ModalButton
      component={ProfileModal}
      disabled={false}
      componentProps={{}}
      enterAnimation={modalSlideUpEnterAnimation}
      leaveAnimation={modalSlideUpLeaveAnimation}
      backdropDismiss
      classes='hover:opacity-80 z-[10] rounded-full p-[0px] bg-border flex items-center justify-center shadow-md'
    >
      <ProfileImage user={user} />
    </ModalButton>
  )
}
